// Copyright (c) 2016 Deere & Company

import RgaDetails, {getDefaultState as getRgaDetails} from '../state/rga-details';
import actions from '../../actions-list';

const setRgaDetails = (state, action) =>
    RgaDetails.update(state, {
        $set: action.rgaDetailsInfo
    });

const updateRgaAnalysisValues = (state, action) => RgaDetails.update(state, {
    [action.property]: {
        $set: action.value
    }
});

export default (state = getRgaDetails(), action) => {

    const actionTypes = {
        [actions.UPDATE_RGA_DETAILS]: setRgaDetails,
        [actions.UPDATE_RGA_RETURNED_ANALYSIS_VALUES]: updateRgaAnalysisValues
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/reducers/rga-details.js